import { IPost } from "../../components/Refs/RefsTable";
import { ISpielComment } from "../types/ref";



export function enforcePostSpielTypes(postSpiels: IPost[])
{
  return postSpiels.map(p =>({
    ...p,
    title: String(p.title),
    platform: String(p.platform),
    date: new Date(p.date),
    voted: Boolean(p.voted) }));
}

export function enforceSpielCommentTypes(spielComments: ISpielComment[])
{
  return spielComments.map(c => ({
    ...c,
    time: new Date(c.time),
    editedTime: c.editedTime ? new Date(c.editedTime) : null,
    deleted: Boolean(c.deleted),
    voted: Boolean(c.voted) }));
}
